import { Icon } from './ducks/types';

export const UNKNOWN_ICON: Icon = { name: 'help', source: 'MaterialCommunity' };

export const OTHER_CATEGORY_ID = 'other';
